/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ContactForm.css';
import fetch from '../../core/fetch';
import $ from 'jquery';

var validate = '';

@withStyles(s)
export default class ContactForm extends Component{
    

    constructor(props) {
        super(props);

        this.state = {
            formData: [],
            formContact: [],
            nom: '',
            courriel: '',
            message: '',
            telephone: '',
            loading: false,
            success: false,
            validate: false,
            error: false,
        }

        this.updateStateNom = this.updateStateNom.bind(this);
        this.updateStateCourriel = this.updateStateCourriel.bind(this);
        this.updateStateMessage = this.updateStateMessage.bind(this);
        this.updateStateTelephone = this.updateStateTelephone.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.formVisible = this.formVisible.bind(this);
        this.validateInput = this.validateInput.bind(this);

    }

    
    componentDidMount(){
        
        // const btnVisible = this.refs.btnVisible;
        // btnVisible.addEventListener('click', this.formVisible);
    }

    updateStateNom(e) {
      
        this.setState({nom: e.target.value});

    }

    updateStateCourriel(e) {
      
        this.setState({courriel: e.target.value});

    }

    updateStateTelephone(e) {
      
        this.setState({telephone: e.target.value});

    }

    updateStateMessage(e) {
      
        this.setState({message: e.target.value});

    }

    clearInput() {
        
        this.setState({nom: ''});
        this.setState({courriel: ''});
        this.setState({telephone: ''});
        this.setState({message: ''});
        this.refs.nom.value = '';
        this.refs.courriel.value = '';
        this.refs.telephone.value = '';
        this.refs.message.value = '';
        
    }

    formVisible() {

        this.setState({success: false});
        
    }

    validateInput() {

        validate = false;

        if(this.refs.nom.value == ''){
            self = this.refs.nom;
            $(self).addClass('borderRed'); 
            validate = !this.state.validate;
        }
        if(this.refs.nom.value != ''){
            self = this.refs.nom;
            $(self).removeClass('borderRed');
        }
        if(this.refs.courriel.value == ''){
            self = this.refs.courriel;
            $(self).addClass('borderRed');
            validate = !this.state.validate;
        }
        if(this.refs.courriel.value != ''){
            self = this.refs.courriel;
            $(self).removeClass('borderRed');
        }
        
        if(this.refs.message.value == ''){
            self = this.refs.message;
            $(self).addClass('borderRed');
            validate = !this.state.validate;
        }
        if(this.refs.message.value != ''){
            self = this.refs.message;
            $(self).removeClass('borderRed');
        }

        if(validate) {
            $('.messageError').css('color', 'red');
        }

        return validate;
    }

    submitForm(e){

        e.preventDefault();

        validate = this.validateInput();

        var form = document.getElementById('formContact');
        var formData = new FormData(form);
        var url = 'http://agenceprolifik.ca/graphql/index.php'

        
        if(validate){

            
        }
        else{

            $.ajax({
                url: url,
                type: "POST",
                data: formData,
                mimeType: "multipart/form-data",
                contentType: false,
                crossDomain: true,
                dataType: "json",
                cache: false,
                processData:false,
                success: function(data, textStatus, jqXHR)
                {
                    
                   
                    this.clearInput()
                    this.setState({success: true});

                    
                }.bind(this),
                error: function(jqXHR, textStatus, errorThrown) 
                {

                    

                }.bind(this)          
            });
        }
    }


    async GetFormContact(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{formContact{id, slug, title, content}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.formContact) throw new Error('Erreur sur le chargement du formulaire contact !');
        
        this.setState({ formContact: data.formContact })
    }

    
    render(){
       

        if(!this.state.success){
            var content =   <form id="formContact" onSubmit={this.submitForm} className={`formContact`}>
                                <input type="hidden" name="contact" />
                                <div className={`wrapInput`}>
                                    <label htmlFor="nom">Votre nom complet *</label><br />
                                    <span className={`nom`}>
                                        <input type="text" name="nom" ref="nom" onChange={this.updateStateNom} value={this.state.nom} className={`inputText`} id="nom" />
                                    </span>
                                </div>
                                <div className={`wrapInput`}>
                                    <label htmlFor="courriel">Votre courriel *</label><br />
                                    <span className={`courriel`}>
                                        <input type="email" name="courriel" ref="courriel" onChange={this.updateStateCourriel} value={this.state.courriel} className={`inputText`} id="courriel" />
                                    </span>
                                </div>
                                <div className={`wrapInput`}>
                                    <label htmlFor="telephone">Votre Téléphone (optionnel)</label><br />
                                    <span className={`courriel`}>
                                        <input type="text" name="telephone" ref="telephone" onChange={this.updateStateTelephone} value={this.state.telephone} className={`inputText`} id="telephone" />
                                    </span>
                                </div>
                                <div className={`wrapInput`}>
                                    <label htmlFor="message">Votre message *</label><br />
                                    <span className={`message`}>
                                        <textarea name="message" ref="message" cols="40" rows="10" onChange={this.updateStateMessage} value={this.state.message} className={`textarea`} id="message"></textarea>
                                    </span>
                                    <span className={`messageError`}>
                                        * Tous les champs sont obligatoires !
                                    </span>
                                </div>
                                <div className={`wrapInput`}>
                                    <input type="submit" value="Soumettre" className={`inputSubmit`} />
                                </div>
                            </form>
        }
        else{
            var content =   <div className={`wrapSuccess`}>
                                <span className={`iconSuccess`}></span>
                                <span className={`titreSuccess`}>Merci de votre intérêt !</span>
                                <span className={`messageSuccess`}>Nous vous répondrons dans les prochains 24h. Pour toutes urgences, communiquez avec nous<br /> au <a href="tel:5143947960"><strong>514 394-7960</strong></a></span>
                                <div className={`wrapBtnSite`}>
                                    <div className={`btnSite`}>
                                        <span><a ref="btnVisible" onClick={this.formVisible}>Envoyer un nouveau message</a></span>
                                    </div>
                                </div>
                            </div>
        }
        return (
            <div className={s.root}>
                {content}
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./components/ContactForm/ContactForm.js